import { AttachmentKindEnum } from '../../../generated/api.graphql';

export const AttachmentKind = Object.freeze({
  DOCUMENT: AttachmentKindEnum.Document,
  IMAGE: AttachmentKindEnum.Image,
});
export type AttachmentKind = (typeof AttachmentKind)[keyof typeof AttachmentKind];

export const MAX_UPLOAD_MB = 10;
const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024;

const ALLOWED_EXTENSIONS: Record<AttachmentKind, string[]> = {
  [AttachmentKind.DOCUMENT]: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'pdf', 'xls', 'xlsx', 'csv'],
  [AttachmentKind.IMAGE]: ['jpg', 'jpeg', 'png', 'webp'],
};

type UploadRejection = 'type' | 'size';

export const acceptFor = (kind: AttachmentKind): string =>
  ALLOWED_EXTENSIONS[kind].map(extension => `.${extension}`).join(',');

// Judged by name, as the server's createDirectUploadUrl does; browsers often leave File#type empty.
export const uploadRejection = (
  file: { name: string; size: number },
  kind: AttachmentKind,
): UploadRejection | null => {
  const dot = file.name.lastIndexOf('.');
  const extension = dot === -1 ? '' : file.name.slice(dot + 1).toLowerCase();
  if (!ALLOWED_EXTENSIONS[kind].includes(extension)) {
    return 'type';
  }
  return file.size > MAX_UPLOAD_BYTES ? 'size' : null;
};
